import { IndexableObject } from '../IndexableObject';
import { objectFilter } from '../objectFilter';

/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to include
 */
export const pick = (
  object: IndexableObject,
  ...filters: Array<string | Array<string>>
): IndexableObject => objectFilter(object, true, ...filters);
